import React, { useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { IFrameWrapper } from './style';
import PopUpModal from '../../../components/General/PopUpModal';

const IFramePopup = () => {
  const ref = useRef();
  const { t, i18n } = useTranslation();
  const { state, pathname } = useLocation();
  const history = useHistory();

  const isTargetPath =
    pathname.includes('customer_enquiries') ||
    pathname.includes('business_enquiries') ||
    pathname.includes('job_vacancies');

  function getBseUrl() {
    if (state?.iframePopup === 'business-enquiry' || state?.iframePopup === 'customer-service') {
      return 'https://support.wilsonparking.com.hk';
    }
    if (state?.iframePopup === 'job-vacancies') {
      return 'https://hr.wilsonparking.com.hk/wilsonparking';
    }

    return '';
  }

  useEffect(() => {
    if (ref.current && state?.iframePopup) {
      setTimeout(() => {
        ref.current.contentWindow.postMessage(
          {
            type: 'languageChange',
            language: i18n.language === 'zh' ? 'zh-TW' : 'en',
          },
          getBseUrl()
        );
      }, 500);
    }
  }, [i18n.language, ref.current, state?.iframePopup]);

  // useEffect(() => {
  //   if (isTargetPath) {
  //     const replaceLanguage = pathname.replace(`/${i18n.language}/`, '');

  //     if (replaceLanguage.includes('/')) {
  //       return;
  //     }

  //     const iframePopup =
  //       replaceLanguage === 'customer_enquiries' ? 'customer-service' : 'business-enquiry';

  //     history.push({
  //       pathname: history.location.pathname,
  //       state: { ...history.location.state, iframePopup },
  //     });
  //   }
  // }, [pathname, i18n.language]);

  if (!state?.iframePopup) {
    return null;
  }

  return (
    <PopUpModal
      Popupshow
      onClose={() => {
        history.push({
          pathname: isTargetPath ? `/${i18n.language}` : history.location.pathname,
          state: { ...history.location.state, iframePopup: null },
        });
      }}
      widthStyle={{ width: '100%', height: '100%', maxWidth: '100%' }}
      style={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}
      mobileStyle={{ width: '100%' }}
      contentStyle={{ height: '100%' }}
      contentContainerStyle={{ height: '100%' }}
    >
      <IFrameWrapper>
        <iframe
          ref={ref}
          title={state.iframePopup}
          style={{ width: '100%', height: '100%' }}
          src={
            state?.iframePopup === 'business-enquiry' || state?.iframePopup === 'customer-service'
              ? `${getBseUrl()}/${state.iframePopup}?lang${i18n.language === 'zh' ? '=zh' : '=en'}`
              : `${getBseUrl()}`
          }
        />
      </IFrameWrapper>
    </PopUpModal>
  );
};

export default IFramePopup;
